<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab
      icon-pack="feather"
      icon="icon-server"
      :label="!isSmallerScreen ? 'General' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <general />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-percent"
      :label="!isSmallerScreen ? 'Expenses' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <expenses />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import General from "./General.vue";
import Expenses from "./Expenses.vue";

export default {
  components: {
    General,
    Expenses,
  },
  data() {
    return {};
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
